/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import ScheduledReportsIcon from 'icons/ScheduledReportsIcon';

const messages = defineMessages({
  title: {id: 'navigation.reports.scheduled-reports'},
});

const ScheduledReportsItem = () => (
  <RouteLinkItem
    iconBefore={ScheduledReportsIcon}
    route="midas/reports/scheduled-reports"
    title={messages.title}
  />
);

export default ScheduledReportsItem;
